<template>
    <div>
        <div
                style="height: 24px; position: relative; padding-left: 24px;"
                :style="`border: 1px solid var(--v-${color}-base);`"
                class="d-flex align-center round"
        >
            <div :style="`background: var(--v-${color}-base);`" style="position: absolute; left: 0; top: 0; width: 101%; height: 101%;" class="round hover-back">

            </div>
            <div
                    style="height: 24px; width: 24px; position: absolute; left: -1px; top: -1px;"
                    :style="`border: 1px solid var(--v-${color}-base);`"
                    class="d-flex align-center justify-center round"
            >
                <v-icon small :color="color">{{icon}}</v-icon>
            </div>
            <div style="line-height: 1" class="caption pr-2 pl-1" :class="`${color}--text`">
                {{label}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        color: {default: 'primary', type: String},
        icon: {default: 'mdi-heart', type: String},
        label: {default: 'Hello', type: [String, Number]},
    }
}
</script>

<style scoped>
    .round{
        border-radius: 12px;
    }

    .hover-back{
        opacity: 0;
        -webkit-transition: opacity .2s ease-out;
        -moz-transition: opacity .2s ease-out;
        -o-transition: opacity .2s ease-out;
        transition: opacity .2s ease-out;
    }

    .hover-back:hover{
        opacity: 0.2;
        -webkit-transition: opacity .2s ease-out;
        -moz-transition: opacity .2s ease-out;
        -o-transition: opacity .2s ease-out;
        transition: opacity .2s ease-out;
    }

    /*.nav-bar-tab-selected{*/
    /*    cursor: pointer;*/
    /*    color: rgba(255,255,255,1);*/
    /*}*/
</style>